import React from 'react';

import Dropdown from 'ui-library/dropdowns/Dropdown';
import BenchlingIcon, {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';
import Menu from 'ui-library/menus/Menu';
import Option from 'ui-library/menus/Option';
import Section from 'ui-library/menus/Section';

export type EditSeparatorDropdownTypes = 'ADD_DATE' | 'REMOVE_DATE' | 'ADD_NAME' | 'REMOVE_NAME' | 'DELETE';

export interface EditSeparatorDropdownProps {
  hasTitle: boolean;
  hasDate: boolean;
  isDateAllowed: boolean;
  isDeleteAllowed: boolean;
  onOptionSelect: (optionType: EditSeparatorDropdownTypes) => void;
}

interface OptionType {
  label: string;
  icon: BenchlingIconName;
  disabled?: boolean;
  value: EditSeparatorDropdownTypes;
}

/**
 * Edits the display of the day separator
 */
export default function EditSeparatorDropdown(props: EditSeparatorDropdownProps): JSX.Element {
  const getOptions = (): React.ReactNode => {
    const optionSections: Array<React.ReactNode> = [];
    const options: Array<OptionType> = [];
    if (props.hasTitle) {
      options.push({
        label: 'Remove section name',
        icon: 'minus',
        disabled: !props.hasDate,
        value: 'REMOVE_NAME',
      });
    } else {
      options.push({
        label: 'Add section name',
        icon: 'plus',
        value: 'ADD_NAME',
      });
    }
    if (props.isDateAllowed) {
      if (props.hasDate) {
        options.push({
          label: 'Remove section date',
          icon: 'minus',
          disabled: !props.hasTitle,
          value: 'REMOVE_DATE',
        });
      } else {
        options.push({
          label: 'Add section date',
          icon: 'plus',
          value: 'ADD_DATE',
        });
      }
    }

    const fieldOptions = options.map((option) => (
      <Option
        icon={option.icon}
        key={option.value}
        isDisabled={option.disabled}
        onSelect={() => {
          props.onOptionSelect(option.value);
        }}
      >
        {option.label}
      </Option>
    ));

    optionSections.push(<Section key={0}>{fieldOptions}</Section>);

    if (props.isDeleteAllowed) {
      optionSections.push(
        <Option
          icon="trash-can"
          key="DELETE"
          onSelect={() => {
            props.onOptionSelect('DELETE');
          }}
        >
          Delete section
        </Option>
      );
    }

    return optionSections;
  };

  return (
    <Dropdown
      menu={
        <Menu width={Menu.WIDTHS.MEDIUM} height={Menu.HEIGHTS.MEDIUM} dropLeft={true}>
          {getOptions()}
        </Menu>
      }
    >
      <BenchlingIcon icon="gear" />
    </Dropdown>
  );
}
